<template>
  <slot />
  <TairoPanels />
</template>
